import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import {setUpStore} from 'client/framework';
import {fromJS, Map, List} from 'immutable';
import FreeEntryInput from './FreeEntryInput.react';
import NumberInput from 'generic/Forms/NumberInput/NumberInput.react';
import {AuthoringQuestionModelV1} from 'resources/augmented/AuthoringQuestion/AuthoringQuestionModel.v1';
import simpleDropdownStore from 'generic/SimpleDropdown/SimpleDropdown.store';
import SimpleDropdown from 'generic/SimpleDropdown/SimpleDropdown.react';
import Button from 'sg/Button/Button.react';
import './free-entry-editor.scss';

const freeEntryTypes = fromJS([
  {
    id: 'contains',
    name: 'Text'
  },
  {
    id: 'mathContains',
    name: 'Math'
  }
]);

export default class FreeEntryEditor extends React.Component {
  static propTypes = {
    question: PropTypes.instanceOf(AuthoringQuestionModelV1),
    onBlur: PropTypes.func,
    onModelChange: PropTypes.func,
    validationErrors: PropTypes.instanceOf(Map)
  };

  getFreeEntryDropdownStore() {
    return setUpStore(simpleDropdownStore, 'FreeEntryDropdownStore');
  }

  onChangeRubricType = (selection) => {
    const updatedQuestion = this.props.question.setRubricType(selection.get('id'));
    this.props.onModelChange(updatedQuestion);
  };

  onChangeThreshold = (e) => {
    const updatedQuestion = this.props.question.setRubricThreshold(e.target.value);
    this.props.onModelChange(updatedQuestion);
  };

  addInput = () => {
    const newInput = Map({
      text: '',
      id: uuid()
    });
    const inputs = this.props.question.getInputs().push(newInput);
    const validResponse = this.props.question
      .getValidResponse()
      .set(newInput.get('id'), List(['']));
    const updatedQuestion = this.props.question.setInputs(inputs).setValidResponse(validResponse);

    this.props.onModelChange(updatedQuestion, 'inputs');
  };

  generateThresholdInput() {
    const rubric = this.props.question.getRubric();
    if (rubric.get('type') !== 'mathContains') {
      return null;
    }

    return (
      <NumberInput
        className='free-entry-editor__threshold'
        label='Threshold %'
        name='threshold'
        placeholder={'1%'}
        onChange={this.onChangeThreshold}
        value={rubric.get('threshold')}
      />
    );
  }

  generateFreeEntryInputs() {
    return this.props.question.getInputs().map((input, key) => {
      return (
        <FreeEntryInput
          index={key}
          input={input}
          key={key}
          question={this.props.question}
          onBlur={this.props.onBlur}
          onModelChange={this.props.onModelChange}
          validationErrors={this.props.validationErrors}
        />
      );
    });
  }

  render() {
    const question = this.props.question;
    const rubric = question.getRubric();
    const errors = this.props.validationErrors;
    const inputsError =
      errors.get('inputs') && typeof errors.get('inputs') === 'string' ? (
        <div className='a-form-input__error'>{errors.get('inputs')}</div>
      ) : null;

    return (
      <div className='free-entry-editor'>
        <SimpleDropdown
          activeItemId={rubric.get('type')}
          label='Answer format'
          options={freeEntryTypes}
          onChange={this.onChangeRubricType}
          storeName={this.getFreeEntryDropdownStore().getName()}
        />
        {this.generateThresholdInput()}
        <hr />
        {inputsError}
        {this.generateFreeEntryInputs()}
        <Button onClick={this.addInput} color='green' text='New input prompt' />
      </div>
    );
  }
}
